import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Deposito } from '../../entity-depositos/depositos.model';
import { ROUTE_ANIMATIONS_ELEMENTS } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { IBaseTable } from 'projects/registro-personas-empresas/src/app/shared/util/base-table.util';
import {
  entityDepositosAddRequest,
  entityDepositosDeleteRequest
} from '../../entity-depositos/depositos.actions';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { RegistroActividadAlmacenamientoFormContainerComponent } from '../registro-actividad-almacenamiento-form-container/registro-actividad-almacenamiento-form-container.component';
import { ConfirmDialogComponent } from 'projects/registro-personas-empresas/src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'rpe-registro-actividad-almacenamiento-tabs',
  templateUrl: './registro-actividad-almacenamiento-tabs-form.component.html',
  styleUrls: ['./registro-actividad-almacenamiento-tabs-form.component.scss']
})
export class RegistroActividadAlmacenamientoTabsFormComponent {
  initial: boolean = false;

  @Input() set actividadDepositoInput({
    deposito,
    edit
  }: {
    deposito: Deposito[];
    edit: boolean;
  }) {
    this.baseTableOptions = {
      ...this.baseTableOptions,
      //Implementar solucion para que no se muestre el deposito null
      //Lo que pasa, es que el deposito null se muestra en la tabla, pero no se puede editar
      //No se porque aparece un deposito null la primera vez que se carga la tabla
      dataSource: deposito.filter((deposito) => deposito.id !== null)
    };

    if (deposito.length === 0 && !edit && !this.initial) {
      this.onAdd();
    }

    this.initial = true;
  }

  @Output() showDepositoEvent: EventEmitter<boolean> =
    new EventEmitter<boolean>(false);

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  baseTableOptions: IBaseTable<Deposito> = {
    dataSource: [],
    columns: [
      {
        caption: 'Número',
        field: {
          key: 'id'
        }
      },
      {
        caption: 'Nombre',
        field: {
          key: 'nombre'
        }
      }
    ],
    actions: [
      {
        name: 'Editar',
        icon: '',
        hide: () => {
          return true;
        },
        action: (element: Deposito) => {
          this.dialog.open(
            RegistroActividadAlmacenamientoFormContainerComponent,
            {
              data: {
                deposito: element
              },
              height: '90vh',
              width: '900px'
            }
          );
        }
      },
      {
        name: 'Borrar',
        icon: '',
        hide: () => {
          return true;
        },
        action: ($event: Deposito) => {
          this.deleteDeposito($event);
        }
      }
    ]
  };

  constructor(private dialog: MatDialog, private store: Store<State>) {}

  onCancel() {
    this.showDepositoEvent.emit(false);
  }

  deleteDeposito($event: Deposito): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Eliminar depósito',
        contentText: `¿Está seguro que desea eliminar el depósito?`,
        submitText: 'Eliminar',
        cancelText: 'Cancelar',
        cancelColor: 'primary'
      }
    });

    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(
          entityDepositosDeleteRequest({
            item: $event
          })
        );
      }
    });
  }

  onAdd() {
    this.dialog.open(RegistroActividadAlmacenamientoFormContainerComponent, {
      data: {
        deposito: null
      },
      height: '90vh',
      width: '900px'
    });
  }
}
